import React, { useState, useEffect } from "react";
import "./NewPatientRegistration.css";

const theme = {
    primaryDark: "#0f172a", primaryBlue: "#1e40af", accentCyan: "#0ea5e9",
    bgLight: "#f8fafc", cardBg: "#ffffff", textMain: "#334155",
    textMuted: "#64748b", borderLight: "#e2e8f0"
};

const PoApprovalsMaster = ({ screenAction, triggerSave }) => {
    const initialFormState = {
        id: null,
        emp_id: "",
        min_value: "0.00",
        max_value: "0.00",
        status: "Active"
    };

    const [formData, setFormData] = useState(initialFormState);
    const [isDisabled, setIsDisabled] = useState(true);
    const [searchText, setSearchText] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [employeesList, setEmployeesList] = useState([]);

    const fetchEmployees = async () => {
        const user = JSON.parse(localStorage.getItem("user"));
        const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/employees/all?employee_id=${user.id}`);
        const data = await res.json();
        setEmployeesList(data);
    };

    useEffect(() => {
        fetchEmployees();
    }, []);

    // 🔍 Search Logic
    const handleSearch = async (text) => {
        setSearchText(text);
        if (text.length < 2) return setSearchResults([]);
        const user = JSON.parse(localStorage.getItem("user"));
        const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/po-approvals/search?q=${text}&employee_id=${user.id}`);
        setSearchResults(await res.json());
        setShowDropdown(true);
    };

    const selectRecord = (item) => {
        setFormData({
            id: item.id,
            emp_id: item.emp_id,
            min_value: parseFloat(item.min_value).toFixed(2),
            max_value: parseFloat(item.max_value).toFixed(2),
            status: item.status
        });
        setSearchText(`${item.emp_name} | ${item.emp_role}`);
        setShowDropdown(false);
    };

    // 🔄 Screen Action Control
    useEffect(() => {
        if (screenAction === "add" || screenAction === "edit") setIsDisabled(false);
        if (screenAction === "view") setIsDisabled(true);
        if (screenAction === "add") setFormData(initialFormState);
          if (screenAction === "print") {
        printForm();
      }
    }, [screenAction]);

    // 💾 Save Trigger
    useEffect(() => {
        if (triggerSave > 0 && screenAction === "save") handleSubmit();
    }, [triggerSave]);

    const handleSubmit = async () => {
        const user = JSON.parse(localStorage.getItem("user"));
        if (!formData.emp_id) return alert("Please select an employee.");

        const payload = { ...formData, created_by: user.id };
        const res = await fetch("https://hmsapi.emedhatechnologies.com/master/api/api/po-approval/save", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload)
        });

        if (res.ok) {
            alert("Approval Settings Saved Successfully");
            setFormData(initialFormState);
            setSearchText("");
        } else alert("Error saving record");
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleNumericBlur = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: parseFloat(value || 0).toFixed(2) }));
    };


    // 🖨️ Print Approval Settings
  const printForm = () => {
    if (!formData.emp_id) return alert("Please select an employee record to print.");

    // Find employee name from the list for the report header
    const selectedEmp = employeesList.find(e => e.id === parseInt(formData.emp_id));
    const empName = selectedEmp ? selectedEmp.name : searchText.split('|')[0] || "Unknown Employee";

    const newWindow = window.open("", "", "width=900,height=700");
    const today = new Date().toLocaleDateString('en-IN', { 
        day: '2-digit', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' 
    });

    const htmlContent = `
      <html>
        <head>
          <title>PO Approval Limits - ${empName}</title>
          <style>
            body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; color: #333; margin: 0; padding: 40px; }
            .header { display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid #1e40af; padding-bottom: 10px; margin-bottom: 30px; }
            .hospital-info h1 { margin: 0; color: #1e40af; font-size: 24px; text-transform: uppercase; }
            .hospital-info p { margin: 2px 0; font-size: 12px; color: #64748b; }
            .report-title { text-align: right; }
            .report-title h2 { margin: 0; color: #0ea5e9; font-size: 18px; }
            
            .main-content { border: 1px solid #e2e8f0; border-radius: 8px; overflow: hidden; }
            .info-row { display: flex; border-bottom: 1px solid #e2e8f0; }
            .info-row:last-child { border-bottom: none; }
            .label { background: #f8fafc; width: 250px; padding: 12px 15px; font-weight: 700; color: #475569; border-right: 1px solid #e2e8f0; font-size: 13px; }
            .value { flex: 1; padding: 12px 15px; font-weight: 500; color: #0f172a; font-size: 14px; }
            .currency { font-family: 'Courier New', Courier, monospace; font-weight: 800; color: #1e40af; }
            
            .footer { margin-top: 60px; display: flex; justify-content: space-between; font-size: 12px; color: #64748b; }
            .signature-line { border-top: 1px solid #333; width: 200px; text-align: center; padding-top: 5px; margin-top: 40px; }
          </style>
        </head>
        <body>
          <div class="header">
            <div class="hospital-info">
              <h1>EMEDHA CARE HOSPITAL</h1>
              <p>Clinical Excellence & Digital Healthcare</p>
            </div>
            <div class="report-title">
              <h2>PO APPROVAL AUTHORIZATION</h2>
              <p>Generated: ${today}</p>
            </div>
          </div>

          <div class="main-content">
            <div class="info-row">
              <div class="label">AUTHORIZED EMPLOYEE</div>
              <div class="value">${empName.toUpperCase()}</div>
            </div>
            <div class="info-row">
              <div class="label">PERMISSION STATUS</div>
              <div class="value" style="color: ${formData.status === 'Active' ? '#15803d' : '#b91c1c'}">
                ${formData.status.toUpperCase()}
              </div>
            </div>
            <div class="info-row">
              <div class="label">MINIMUM APPROVAL LIMIT</div>
              <div class="value currency">₹ ${formData.min_value}</div>
            </div>
            <div class="info-row">
              <div class="label">MAXIMUM APPROVAL LIMIT</div>
              <div class="value currency">₹ ${formData.max_value}</div>
            </div>
          </div>

          <p style="font-size: 11px; color: #64748b; margin-top: 20px; font-style: italic;">
            Note: This document confirms the financial authority granted to the above-mentioned employee for Purchase Order approvals within the EMEDHA HMS system.
          </p>

          <div class="footer">
            <div>
              <div class="signature-line">Administrator Signature</div>
            </div>
            <div>
              <div class="signature-line">Employee Acknowledgement</div>
            </div>
          </div>
        </body>
      </html>
    `;

    newWindow.document.write(htmlContent);
    newWindow.document.close();

    setTimeout(() => {
      newWindow.print();
      newWindow.close();
    }, 500);
  };

    return (
        <div className="registration-container fade-in">
            
            {/* SEARCH SECTION */}
            {(screenAction === "edit" || screenAction === "view") && (
                <div className="patient-search">
                    <label>Search Employee Permissions</label>
                    <input type="text" value={searchText} placeholder="Search by Name or Role..." onChange={(e) => handleSearch(e.target.value)} />
                    {showDropdown && searchResults.length > 0 && (
                        <div className="patient-dropdown">
                            {searchResults.map(r => (
                                <div key={r.id} className="patient-item" onClick={() => selectRecord(r)}>
                                    {r.emp_name} | {r.emp_role} | {r.min_value} - {r.max_value}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}

            <form className="luxury-form">
                <div className="form-section-header">
                    <h3>Employee Approval Limit Settings</h3>
                </div>
                
                <div className="form-grid">
                    {/* Employee Selection */}
                    <div className="input-box">
                        <label>Select Employee <span style={{color:'red'}}>*</span></label>
                        <select name="emp_id" value={formData.emp_id} onChange={handleChange} disabled={isDisabled || formData.id}>
                            <option value="">-- Choose Employee --</option>
                            {employeesList.map(emp => (
                                <option key={emp.id} value={emp.id}>{emp.name} ({emp.role})</option>
                            ))}
                        </select>
                    </div>

                    {/* Status */}
                    <div className="input-box">
                        <label>Status</label>
                        <select name="status" value={formData.status} onChange={handleChange} disabled={isDisabled}>
                            <option value="Active">Active</option>
                            <option value="Inactive">Inactive</option>
                        </select>
                    </div>

                    {/* Min Value */}
                    <div className="input-box">
                        <label>Minimum PO Amount (₹)</label>
                        <input 
                            type="number" 
                            name="min_value" 
                            value={formData.min_value} 
                            onChange={handleChange} 
                            onBlur={handleNumericBlur}
                            disabled={isDisabled} 
                            style={{textAlign: 'right'}}
                        />
                    </div>

                    {/* Max Value */}
                    <div className="input-box">
                        <label>Maximum PO Amount (₹)</label>
                        <input 
                            type="number" 
                            name="max_value" 
                            value={formData.max_value} 
                            onChange={handleChange} 
                            onBlur={handleNumericBlur}
                            disabled={isDisabled} 
                            style={{textAlign: 'right'}}
                        />
                    </div>
                </div>

                {/* Info Note */}
                <div style={{marginTop: '20px', padding: '15px', background: '#eff6ff', borderRadius: '8px', borderLeft: '4px solid #1e40af'}}>
                    <p style={{margin: 0, fontSize: '12px', color: '#1e40af', fontWeight: '500'}}>
                        <strong>Note:</strong> This employee will only be able to approve Purchase Orders where the total amount falls between the defined Min and Max values.
                    </p>
                </div>
            </form>
        </div>
    );
};

export default PoApprovalsMaster;